var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.followSvgComponents),function(component,index){return _c('a',{key:index,attrs:{"href":component.url,"target":"_blank"}},[_c(component.svg,{key:index,tag:"component",staticClass:"image-footer mr-3"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }